import styled from "styled-components";

export const CollapseWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

export const CollapseHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 1rem;
    border-radius: 0 0 0.5rem 0.5rem;
    
    user-select: none;
    svg {
        margin-right: 1rem;
        transition: transform 0.2s linear;
    }

    &:hover {
        cursor: pointer;
        font-size: 1.02rem;
    }
    &.active {
        svg {
            transform: rotate(90deg);
        }
    }
`;

export const CollapseContent = styled.div`
    width: 100%;
    //flex: 1;
    position: absolute;
    visibility: hidden;
    display: none;
    opacity: 0;
    &.active {
        visibility: visible;
        position: inherit;
        transition: opacity 0.5s linear;
        opacity: 1;
        display: flex;
    }
`;